export const ROLE_ADMIN = 'admin-role';
export const ROLE_ANALYTIC = 'analytic-role';
export const ROLE_EXPERT = 'expert-role';
